import * as React from 'react'
import { Link, PageProps } from 'gatsby'
import styled from 'styled-components'
import intl from 'react-intl-universal'
import { PageContextType } from './type'
import bg from './images/bg.png'
import bgMb from './images/bg_mobile.png'
import ufo from './images/ufo.png'
import cloud_left from './images/cloud-right.png'
import cloud_right from './images/cloud-right.png'
import { Layout, Seo, Media, mbSize, pcSize } from '../../..'
import { LOCALE } from '@foxrenderfarm/internals'

export const NotFoundCommonPage = ({
  pageContext: {
    i18n: { locale },
    prefix,
    homepage,
    I18N_LOCALE,
  },
}: PageProps<object, PageContextType>) => {
  const homeLink = homepage ?? (locale === LOCALE.EN ? '/' : `/${locale}/`)
  return (
    <Layout prefix={prefix} isMultilingual={true} displayLanguages={I18N_LOCALE}>
      <Seo
        title='404 Error Page | Fox Render Farm'
        description='404 Error Page'
        keywords='404 Error Page'
        sharePostSlug='404.html'
        lang={locale}
      />
      <Wrapper>
        <BgImg src={bg} alt='404' />
        <BgImgMb src={bgMb} alt='404' />
        <Content>
          <CloudLeft src={cloud_left} alt='404' />
          <UFO src={ufo} alt='404' />
          <CloudRight src={cloud_right} alt='404' />
          <TextArea $isEn={locale === LOCALE.EN}>
            <h1 className='title'>{intl.get('error.title')}</h1>
            <h2 className='tip'>{intl.get('error.text1')}</h2>
            <div className='button-wrapper'>
              <Link to={homeLink} className='left'>
                {intl.get('error.button1')}
              </Link>
              <Link
                to={locale === LOCALE.EN ? '/client-works.html' : `/${locale}/client-works.html`}
                className='right'
              >
                {intl.get('error.button2')}
              </Link>
            </div>
          </TextArea>
        </Content>
      </Wrapper>
    </Layout>
  )
}

const ContentWrapper = styled.div`
  position: relative;
  width: 1200px;
  margin: 0 auto;
  ${Media.lessThan(Media.small)} {
    width: 100vw;
  }
`

export const BgImg = styled.img`
  position: absolute;
  top: 516px;
  left: 0;
  right: 0;
  width: 100%;
  height: ${pcSize(1037)};
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

export const BgImgMb = styled.img`
  display: none;
  ${Media.lessThan(Media.small)} {
    display: block;
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    height: ${mbSize(240)};
    bottom: 0;
  }
`

export const CloudLeft = styled.img`
  position: absolute;
  width: 116px;
  height: 59px;
  left: -23px;
  top: 388px;
  transform: translate(-100%, 0);
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(140)};
    height: ${mbSize(71)};
    top: ${mbSize(900)};
    left: ${mbSize(16)};
    transform: unset;
  }
`

export const CloudRight = styled.img`
  position: absolute;
  width: 98px;
  height: 50px;
  right: -12px;
  transform: translate(100%, 0);
  top: 226px;
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

export const UFO = styled.img`
  position: relative;
  margin-top: 180px;
  width: 541px;
  height: 557px;
  ${Media.lessThan(Media.small)} {
    position: absolute;
    top: ${mbSize(420)};
    margin-top: 0;
    width: ${mbSize(670)};
    height: ${mbSize(626)};
  }
`

export const Wrapper = styled.div`
  position: relative;
  flex: 1;
  height: 860px;
  background: #e3f4ff;
  min-width: 1200px;
  overflow: hidden;
  * {
    font-family: 'MarkPro';
    color: #3d3d3d;
  }
  ${Media.lessThan(Media.small)} {
    min-width: 100vw;
    height: ${mbSize(1460)};
  }
`

export const Content = styled(ContentWrapper)`
  display: flex;
  justify-content: space-between;
  height: 100%;
  ${Media.lessThan(Media.small)} {
    flex-direction: column;
    align-items: center;
  }
`

export const TextArea = styled.div<{ $isEn: boolean }>`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 300px;
  .title {
    font-size: 64px;
    font-weight: bold;
  }
  .tip {
    font-size: 20px;
    font-weight: unset;
    margin: 4px 0 53px 0;
  }
  .button-wrapper {
    display: flex;
    justify-content: space-between;
  }
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 240px;
    height: 50px;
    border-radius: 100px;
    font-size: 16px;
    font-weight: bold;
    &:hover {
      box-shadow: 0px 18px 26px 0px rgba(41, 98, 135, 0.2);
    }
    &.left {
      color: #ffffff;
      margin-right: 20px;
      background: #ef572e;
    }
    &.right {
      color: #ef572e;
      border: 1px solid #ef572e;
    }
  }
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(240)};
    .title {
      font-size: ${({ $isEn }) => mbSize($isEn ? 72 : 64)};
    }
    .tip {
      font-size: ${mbSize(28)};
      margin: ${mbSize(16)} 0 ${mbSize(696)} 0;
    }
    .button-wrapper {
      flex-direction: column;
      align-items: center;
    }
    a {
      width: ${mbSize(440)};
      height: ${mbSize(72)};
      font-size: ${mbSize(24)};
      border-radius: ${mbSize(200)};
      &.left {
        margin-right: unset;
        margin-bottom: ${mbSize(48)};
      }
    }
  }
`
